// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  position: fixed;
  top: 0;
  right: 0px;
  left: 220px;
  height: 72px;
  padding-left: 32px;
  padding-right: 32px;
  
  z-index: 3;

  display: flex;
  justify-content: space-between;
  align-items: center;
  
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.welcome-section {
  color: var(--N2-Grey-696969, #696969);
  font-family: "Segoe UI";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.hi-container {
  color: var(--Gry_707070, #707070);
  text-align: right;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 6px;
}
.icon-container{
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #E0F6F8;
  text-align: center;
}
.user-group{
display: flex;
}
.user-section {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: #f5f5f5;
}

.user-info .ant-avatar {
  width: 36px;
  height: 36px;
  margin-right: 12px;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #1d2129;
}

.user-role {
  font-size: 12px;
  color: #86909c;
}
.name-init{
  line-height: 32px;
 color: #00B9C1;
text-align: center;
font-family: "Segoe UI";
font-size: 14px;
font-style: normal;
font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/header/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;;EAEnB,UAAU;;EAEV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;AACA,aAAa;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;CAClB,cAAc;AACf,kBAAkB;AAClB,uBAAuB;AACvB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB","sourcesContent":[".header-container {\n  position: fixed;\n  top: 0;\n  right: 0px;\n  left: 220px;\n  height: 72px;\n  padding-left: 32px;\n  padding-right: 32px;\n  \n  z-index: 3;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  background-color: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.welcome-section {\n  color: var(--N2-Grey-696969, #696969);\n  font-family: \"Segoe UI\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.hi-container {\n  color: var(--Gry_707070, #707070);\n  text-align: right;\n  font-family: \"Nunito Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-right: 6px;\n}\n.icon-container{\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: #E0F6F8;\n  text-align: center;\n}\n.user-group{\ndisplay: flex;\n}\n.user-section {\n  display: flex;\n  align-items: center;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n.user-info:hover {\n  background-color: #f5f5f5;\n}\n\n.user-info .ant-avatar {\n  width: 36px;\n  height: 36px;\n  margin-right: 12px;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1d2129;\n}\n\n.user-role {\n  font-size: 12px;\n  color: #86909c;\n}\n.name-init{\n  line-height: 32px;\n color: #00B9C1;\ntext-align: center;\nfont-family: \"Segoe UI\";\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
